<template>
    <div v-if="months != null && !isQuickAdd && (months[0].length > 0 || months[1].length > 0)">
        <div class="col-xs-12 col-sm-12" :class="{'col-md-6 col-lg-6': months.length > 1, 'col-md-12 col-lg-12': months.length == 1 }" v-for="collection in months">
            <div v-for="month in collection">
                <div class="box-layout-inner">
                    <div class="title-block">
                        {{ month.month }}
                    </div>

                    <ul class="content-links weeks-list">
                        <li v-for="date in month.dates">
                            <a @click="progress(this, date)">
                                <i id="updateCalender" class="fa fa-calendar"></i>

                                <span class="title" v-html="date.title"></span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-show="months.length == 0">
            <div class="box-layout-inner">
                <div class="title-block" v-if="age <= 4" v-html="locale.text_empty_4_years"></div>
                <div class="title-block" v-else v-html="locale.text_empty"></div>
            </div>
        </div>
    </div>
    <div v-else-if="months != null && months.length > 0 && isQuickAdd">
        <div class="fields dropdown">
            <label for="dates_available">Dates<small v-if="!quickSelection.week"> - Please select dates to attend</small></label>

            <div class="dropdown-inner">
                <select name="dates_available" id="dates_available" v-model="quickSelection.week">
                    <optgroup v-for="month in months" :label="month.month" v-if="months.length > 0">
                        <option v-for="date in month.dates" :value="date.id" v-html="date.title"></option>
                    </optgroup>
                    <option :value="quickSelection.week" v-if="months.length == 0" hidden selected>There are no weeks available</option>
                </select>

                <i class="fa fa-chevron-down"></i>
            </div>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <div class="box-layout-inner">
            <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
        </div>
    </div>
</template>

<script>
    Number.prototype.nth= function(){
        if(this%1) return this;
        var s= this%100;
        if(s>3 && s<21) return this+'<sup>th</sup>';
        switch(s%10){
            case 1: return this+'<sup>st</sup>';
            case 2: return this+'<sup>nd</sup>';
            case 3: return this+'<sup>rd</sup>';
            default: return this+'<sup>th</sup>';
        }
    }

    export default {
        props: ['quick', 'participant', 'quickSelection'],
        data () {
            return {
                months: null,
                age: null,
                min_age: null,

                loading: true,
            }
        },
        computed: {
            isQuickAdd: function () {
                return this.quick != undefined && this.quick == true;
            },
            locale: function () {
                return this.$root.locale.booking.weeks;
            }
        },
        watch: {
            '$route.query' () {
                this.refresh();
            }
        },
        methods: {
            refresh: function () {
                this.loading = true;
                var max_age = this.age = (this.$route.query.hasOwnProperty('age') ? this.$route.query.age : (this.$root.builder.hasOwnProperty('age') ? this.$root.builder.age : null ) );
                var min_age = this.min_age = (this.$route.query.hasOwnProperty('min_age') ? this.$route.query.min_age : (this.$root.builder.hasOwnProperty('min_age') ? this.$root.builder.min_age : null ) );
                var week = this.min_age = (this.$route.query.hasOwnProperty('week') ? this.$route.query.week : (this.$root.builder.hasOwnProperty('week') ? this.$root.builder.week : null ) );


                // I'VE REMOVED THIS BECAUSE WHEN USING THE BREADCRUMBS FROM THE PACKAGE SELECTION SCREEN AFTER A URL FROM KINGS, CHANGING THE WEEK RETURNS AN ERROR ABOUT NO AGE SELECTED (JT)
                // if(!max_age && !min_age && !this.isQuickAdd && !week) {
                //     this.$root.alert(this.locale.text_empty);
                //     this.$router.push({ name: (!this.isQuickAdd ? 'booking.age' : 'cart.basket') });
                //     return true;
                // }
                //if(max_age == null && !this.isQuickAdd)
                    //this.$router.push({ name: 'booking.age' });

                /**
                 * Getting all the venues to fill the select dropdown to select a venue.
                 */
                axios.get('camp-booking/venues/'+this.$route.params.venueId+'/weeks', {
                    params: {
                        age: (this.isQuickAdd ? null : max_age),
                        price_per: 'week'
                    }
                }).then(response => {
                    var tmp = [];
                    if(!response.data.data.length) {
                        this.$root.alert((max_age <= 4 ? this.locale.text_empty_4_years : this.locale.text_empty));
                        this.$router.push({ name: (!this.isQuickAdd ? 'booking.age' : 'cart.basket') });
                    }
                    response.data.data.forEach(function (object) {
                        var startArray = object.start.split("-");
                        var start = new Date(startArray[0], startArray[1]-1, startArray[2]);

                        tmp[start.getMonth()] = {
                            month: start.getStrMonth(),
                            year: start.getFullYear(),
                            dates: (tmp[start.getMonth()] == undefined ? [] : tmp[start.getMonth()].dates)
                        };
                        tmp[start.getMonth()].dates.push({title:start.formatRange(object.end),id:object.id,start:object.start,end:object.end,programmes:object.programmes});
                    });
                    var monthsArray = tmp.filter(function f(n){
                        return n != undefined
                    });


                    if(!this.isQuickAdd) {
                        var months = [[], []];
                        for(let i = 0; i < monthsArray.length; ++i) {
                            if (i < monthsArray.length / 2)
                                months[0].push(monthsArray[i])
                            else
                                months[1].push(monthsArray[i])
                        }
                        this.months = months;
                    } else {
                        this.months = monthsArray;
                    }
                    this.loading = false;

                    /**
                     * Setting the headers
                     **/
                    if(!this.isQuickAdd)
                        this.$root.headers = {
                            navigate: {
                                name: 'booking.age'
                            },
                            title: "Select a week",
                            breadcrumbs: [
                                {
                                    to: {
                                        name: 'booking.age',
                                        query: {}
                                    },
                                    title: this.$root.locale.miscellaneous.page_headings.booking.select_weeks,
                                }
                            ],
                            allow_change: true,

                        }
                })
            },
            progress: function (event, date) {

                var progress_data = null;
                var router_push_args = null;

                //Do we have an age?
                if(this.age == null) {
                    progress_data = {
                        date
                    }

                    router_push_args = {
                        name: 'booking.packages',
                        query: {
                            week: date.id
                        }
                    };

                } else {
                    progress_data = {
                        date,
                        age: (this.age != null ? this.age : undefined),
                        min_age: (this.min_age != null ? this.min_age : undefined)
                    }

                    router_push_args = {
                        name: 'booking.packages',
                        query: {
                            age: (this.age != null ? this.age : undefined),
                            week: date.id,
                            min_age: (this.min_age != null ? this.min_age : undefined)
                        }
                    };
                }

                this.$emit('updatebuilder', {
                    method: 'append',
                    data: progress_data
                });

                this.$router.push(router_push_args);
            },
        },
        created() {
            this.refresh();
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// WeeksAvailable.vue?5ac5cc44